<template>
  <a-card :bordered="false">

    <!-- 上部订单查询 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" style="float:left">
            <a-form-item label="客户名称">
              <a-select showSearch  v-model="queryParam.bussinessid" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                 <a-select-option value=''>请选择</a-select-option>
                <a-select-option v-for="(item, index) in businessSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="24" style="float:left">
            <a-form-item label="物料">
              <a-select showSearch  v-model="queryParam.materialid" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option value=''>请选择</a-select-option>
                <a-select-option v-for="(item, index) in materielList" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
             <a-col :md="10" :sm="24">
              <a-form-item
                label="结算时间"
                :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              >
                <a-range-picker
                  v-model="queryParam.jiesuanTime"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{ '今天': [moment().startOf('day'), moment().endOf('day')], '本月': [moment().startOf('month'), moment().endOf('day')] }"
                  showTime
                  format="YYYY-MM-DD"
                  v-decorator="[
                      'dateRange',
                      {rules: [{ required: true, message: '请选择结算时间'}]}
                    ]"
                />
              </a-form-item>
            </a-col>
<!--
          <a-col :md="5" :sm="24">
            <a-form-item label="查询年份">
              <a-select  showSearch  v-model="queryParam.queryYear" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in yearList" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="24">
            <a-form-item label="查询月份">
              <a-select showSearch  v-model="queryParam.queryMonth" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in monthList" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
-->
          <a-col :md="6" :sm="24" style="float:right">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh()">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
      <div class="table-operator">

      <a-button style="margin-left: 0px" type="primary" @click="handlexsExport()">销售明细</a-button>
     </div>

    <s-table ref="table" size="small" :bordered="config.globlaBordered" :rowKey="(record) => record.id"
      :columns="columns" :data="loadData"
       :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"">

      <template slot="footer" slot-scope="currentPageData">
        <div>
         <!-- <span style="margin-left:560px; font-size:14px;font-weight: 500;">
            备注：可用余额 = 上月结余金额 + 本月充值总金额 + 信用额度 - 发货总金额 - 在执行订单金额
          </span> -->
       </div>
       <div>
         <!-- <span style="margin-left:630px; font-size:14px;font-weight: 500;">
            余额 = 上月结余金额 + 本月充值总金额 - 发货总金额
          </span> -->
       </div>
      </template>

    </s-table>

  </a-card>
</template>

<script>

import { STable } from '@/components'
import { corpBusinessList, materielList } from '@/api/basic'
import { orderXsStatsPage } from '@/api/order'
import { xsdetils } from '@/api/logistics'
import moment from 'moment'
import { formatDate } from '../../utils/date.js'
import { formatCurrency } from '@/utils/util'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'


export default {
  name: 'ReceiptDetails',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList: ['10'],
      businessSelect: [],
      materielList: [],
      description: '收款明细',

      // 查询参数
      // queryParam: {queryMonth:moment().startOf('month').format('MM').replace(/\b(0+)/gi,"") , startDate:moment().startOf('month'), endDate:moment(new Date(), 'YYYY-MM-DD')},
      //queryParam: { queryYear: moment().startOf('year').format('YYYY'), queryMonth: moment().startOf('month').format('MM'), startDate: moment().startOf('month'), endDate: moment(new Date(), 'YYYY-MM-DD') },
      queryParam: {},
      totalAmount: 0,
      footerDataSource: [],  //    :footer="handleFooterShow"
      yearList: [
        { id: 2020, name: 2020 },
      ],
      monthList: [
        { id: '01', name: "一月份" },
        { id: '02', name: "二月份" },
        { id: '03', name: "三月份" },
        { id: '04', name: "四月份" },
        { id: '05', name: "五月份" },
        { id: '06', name: "六月份" },
        { id: '07', name: "七月份" },
        { id: '08', name: "八月份" },
        { id: '09', name: "九月份" },
        { id: '10', name: "十月份" },
        { id: '11', name: "十一月份" },
        { id: '12', name: "十二月份" },
      ],
      // 表头
      columns: [
        {
          title: '客户名称',
          dataIndex: 'bname',
          /*    width: '300px'  */
        },
        {
          title: '物料名称',
          dataIndex: 'mname',
          width: '140px',

        },
        {
          title: '车次',
          dataIndex: 'countVehicleNo',
          width: '140px',

        },
        {
          title: '净重',
          dataIndex: 'sumnet',
          width: '140px',

        },
        {
          title: '单价',
          dataIndex: 'materielprice',
          width: '140px',

        },
        {
          title: '发货金额',
          dataIndex: 'sumMoneyS',
          width: '140px',

        }
      ],


      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        if (this.queryParam.jiesuanTime !== undefined && this.queryParam.jiesuanTime.length > 1) {
          this.queryParam['start'] = formatDate(new Date(this.queryParam.jiesuanTime[0]), 'yyyy-MM-dd')
          this.queryParam['end'] = formatDate(new Date(this.queryParam.jiesuanTime[1]), 'yyyy-MM-dd')
        } else {
          this.queryParam['start'] = null
          this.queryParam['end'] = null
        }
        const token = Vue.ls.get(ACCESS_TOKEN)


        // window.location.href =
        // this.config.downloadxsWeighingUrl +
        //'&accessToken=' +
        //token +
        //'&type=data'+
        //'&bussinessid=' +
        //this.queryParam.businessId +
        //'&materialid=' +
        //this.queryParam.materielId +
        //'&start=' +
        //this.queryParam['start'] +
        //'&end=' +
        //this.queryParam['end']
        //if (this.queryParam. > this.queryParam.endDate){
        //   this.$message.warning('开始日期不能大于结束日期',3)
        //   return
        // }
        //{ accessToken: token, type: "show", bussinessid: this.queryParam.businessId, materialid: this.queryParam.materielId, start: this.queryParam['start'], end: this.queryParam['end'] }
        return xsdetils(Object.assign(parameter, this.queryParam)
        ).then(res => {
          console.log("条数" + res.data)

          return res.data

        })
      },
      loadSelect() {
        new Promise(resolve => {
          const data = corpBusinessList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.businessSelect = res
        })

        new Promise(resolve => {
          const data = materielList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.materielList = res
        })
      },
    }
  },
  created() {
    this.loadSelect()

    // 初始化查询条件
    this.queryParam = this.queryParam || null
    var myDate = new Date();
    var thisYear = myDate.getFullYear(); // 获取当年年份
    var section = thisYear - 2020; // 声明一个变量 获得当前年份至想获取年份差 eg.2008
    var arrYear = []; // 声明一个空数组 把遍历出的年份添加到数组里
    for (var i = 0; i <= section; i++) {
      let year = thisYear--
      arrYear.push({ 'id': year, 'name': year })
    }
    this.yearList = arrYear
  },

  methods: {
    handlexsExport() {
      const token = Vue.ls.get(ACCESS_TOKEN)
      console.log("ACCESS_TOKEN:" + ACCESS_TOKEN + "/" + token)
      window.location.href =
        this.config.downloadxsWeighingUrl +
        '&accessToken=' +
        token +
        '&type=excel' +
        '&bussinessid=' +
        this.queryParam.bussinessid +
        '&materialid=' +
        this.queryParam.materialid +
        '&start=' +
        this.queryParam['start'] +
        '&end=' +
        this.queryParam['end']
    },
    moment,

    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },

  watch: {}
}
</script>

<style scoped>
/deep/ .ant-form-item {
  margin-bottom: 10px;
}
</style>